import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Categories from './Categories'
import SearchFilter from './SearchFilter'
import FiltersTags from './FiltersTags'
import FindTutorClassBanners from './FindTutorClassBanners'
import FAQ from '../../../components/Shared/FAQ'
import { getStudentGoal } from 'routing/fetchingfunction/user/user.action'
import { selectStudentGoal } from 'routing/fetchingfunction/user/user.reducer'

const FindTutor = () => {
  const dispatch = useDispatch()
  const studentGoal = useSelector(selectStudentGoal)

  const [filters, setFilters] = useState({
    class_banner_category: '_',
    search: '',
    sort: 'name_a_z',
    languages: '_',
    price: '_',
    rating: '_',
    class_banner_level: '_',
    timezone: '_',
    time_preferences: '',
    country_of_origin: '_',
    country_of_residence: '_',
  })

  useEffect(() => {
    if (!studentGoal) {
      dispatch(getStudentGoal())
    } else if (studentGoal) {
      setFilters((prev) => ({
        ...prev,
        class_banner_category: studentGoal.class_type || '_',
        country_of_origin: studentGoal?.tutor_origin_country || '_',
        country_of_residence: studentGoal?.tutor_residence_country || '_',
        time_preferences: studentGoal?.comfortable_time || '_',
      }))
    }
  }, [studentGoal, dispatch])

  const handleChangeFilters = (name, value) => {
    setFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  return (
    <>
      <section aria-labelledby="find-tutor-heading">
        <div className="max-w-[1280px] w-full mx-auto flex flex-col items-start pt-[32px] pb-[80px]">
          <h1 id="find-tutor-heading" className="w-full text-4xl font-bold text-center text-white">
            Search for Tutors and Teachers for Private Lessons
          </h1>

          <Categories
            value={filters.class_banner_category}
            onChange={(value) => handleChangeFilters('class_banner_category', value)}
          />

          <SearchFilter
            filters={filters}
            onChangeFilters={handleChangeFilters}
            setFilters={setFilters}
          />

          <FiltersTags filters={filters} onChangeFilters={handleChangeFilters} />

          <FindTutorClassBanners filters={filters} />
        </div>
      </section>

      <FAQ />
    </>
  )
}

export default FindTutor
